import { Component, EventEmitter, Input } from '@angular/core';
import { AvanoButtonBarButtonDetails, AvanoButtonBarGroup } from './avano-button-bar.common';

/*
 * TODO:
 *  * Dropdown if width is not enough
 *  * Collapse/Expand all together with avano panel
 *  * Help-Button emit event or other way?
 *
 * */

@Component({
  selector: 'avano-button-bar',
  templateUrl: './avano-button-bar.component.html',
  styleUrls: ['./avano-button-bar.component.scss']
})
export class AvanoButtonBarComponent {
  @Input() buttonsData: AvanoButtonBarButtonDetails[];

  buttonGroup: typeof AvanoButtonBarGroup = AvanoButtonBarGroup; // For usage in template

  // @Input()
  enableHelp: boolean;
  // @Input()
  enableExpandCollapse: boolean;

  // @Output()
  openHelp: EventEmitter<void> = new EventEmitter();

  constructor() {}

  public requestHelp(): void {
    this.openHelp.emit();
  }
}
